<template>
  <div class="page-login">
    <div class="columns is-centered">
      <form @submit.prevent="submitForm" id="login-form">
        <div class="card">
          <div class="card-header">
            <h1 class="card-header-title title is-4 has-text-centered">
              Ingresa tu usuario y contraseña
            </h1>
          </div>
          <div class="card-content">
            <div class="field">
              <div class="control has-icons-left">
                <input
                  type="text"
                  class="input is-large"
                  v-model="username"
                  autocomplete="username"
                  placeholder="Usuario"
                  autocapitalize="none"
                  required
                />
                <span class="icon is-normal is-left">
                  <span class="material-symbols-outlined">person</span>
                </span>
              </div>
            </div>
            <div class="field">
              <div class="control has-icons-left">
                <input
                  class="input is-large"
                  type="password"
                  v-model="password"
                  autocomplete="current-password"
                  placeholder="Contraseña"
                  required
                />
                <span class="icon is-normal is-left">
                  <span class="material-symbols-outlined">password</span>
                </span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="card-footer-item">
              <button class="button is-primary" type="submit">Ingresar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="notification is-danger" v-if="errors.length">
      <p v-for="error in errors" v-bind:key="error">
        {{ error }}
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      username: "",
      password: "",
      errors: [],
    };
  },
  computed: {
    isAuthenticated() {
      return localStorage.get("token");
    },
  },
  methods: {
    async submitForm() {
      const formData = {
        username: this.username,
        password: this.password,
      };

      const form = document.getElementById("login-form");
      if (form.checkValidity()) {
        await axios
          .post("/api/v1/login/", formData)
          .then((response) => {
            // console.log(response);

            const token = response.data.token;
            this.$store.commit("setToken", token);
            localStorage.setItem("token", token);
            axios.defaults.headers.common["Authorization"] = "Token " + token;
            this.$router.push("/shops");
          })
          .catch((error) => {
            // console.log(error);

            if (error.response) {
              this.errors = [];
              for (const property in error.response.data) {
                this.errors.push(
                  `${property}: ${error.response.data[property]}`
                );
              }
            } else {
              this.errors.push("Algo salió mal! :{");
              // console.log(error);
            }

            if (error.message) {
              this.errors.push(`Algo salió mal! :{ (${error.message})`);
            }

            axios.defaults.headers.common["Authorization"] = "";
            this.$store.commit("removeToken");
          });
      }
    },
  },
  mounted() {
    document.title = "Coffee Shop Admin - POS";
  },
};
</script>
